import React, { useRef, useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import FeedbackForm from '@/components/Forms/FeedbackForm';
import PublicPage from '@/components/Pages/PublicPage';
import MetaHead from '@/components/MetaHead';
import SubmitButton from '@/components/Buttons/SubmitButton';
import { View } from 'react-native';

export default function FeedbackPage() {
  const { t } = useTranslation();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      if (formRef.current) {
        await formRef.current.handleSubmit();
      } else {
        // console.warn('[FeedbackPage] formRef.current is null/undefined');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PublicPage
      title={t('feedback.title')}
      subtitle={t('feedback.subtitle')}
    >
      <MetaHead 
        title="Feedback"
        description="Share your thoughts and help shape the future of Gab AI. Your feedback is valuable to us and helps improve our Super Intelligence services and user experience."
      />
      <View style={{ gap: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <FeedbackForm ref={formRef} onValidityChange={setIsValid} />
        <View style={{ width: '100%' }}>
          <SubmitButton
            onPress={handleSubmit}
            isLoading={isSubmitting}
            isDisabled={!isValid}
            title={isSubmitting ? t('feedback.form.submitting') : t('feedback.form.submit')}
          />
        </View>
      </View>
    </PublicPage>
  );
}
